import { render, staticRenderFns } from "./merchantCenterHome.vue?vue&type=template&id=268c0ed3&scoped=true"
import script from "./merchantCenterHome.vue?vue&type=script&lang=js"
export * from "./merchantCenterHome.vue?vue&type=script&lang=js"
import style0 from "./merchantCenterHome.vue?vue&type=style&index=0&id=268c0ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268c0ed3",
  null
  
)

export default component.exports